import React from 'react';
import Header from '../components/header/HeaderOne';
import Footer from '../components/footer/FooterOne';

import Breadcrumb from '../components/sections/Breadcrumb';

import PriceSecOne from '../components/sections/PriceSecOne';
import CtaSecOne from '../components/sections/CtaSecOne';
import TestimonialSecOne from '../components/sections/TestimonialSecOne';

const Pricing = () => {
  return (
    <>
      <Header />
        <Breadcrumb titleKey="sections.breadcrumb.pricing.title" subtitleKey="sections.breadcrumb.pricing.subtitle" />
        <PriceSecOne className="space overflow-hidden" />
        <CtaSecOne className="space bg-smoke overflow-hidden" />
        <TestimonialSecOne className="space overflow-hidden bg-auto" />
      <Footer />
    </>
  );
};

export default Pricing;